<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import Loader from "@/components/widgets/preloader";
import { mapGetters,mapActions,mapState } from "vuex"
import moment from "moment";
import axios from "axios";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Debtors Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Loader,
  },
  data() {
    return {
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Debtors Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Debtors",
          active: true,
        },
      ],
      data: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: moment().subtract(3, 'months').format('YYYY-MM-DD'),
        customer: "",
        branch_id:0
      },
      totalRows: 1,
      filterTitle:'Debtors Report',
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      filteredReport:[],
      totals:{
        totalAmount:0,
        totalPaid:0,
        totalDiscount:0,
        totalBalance:0,
      },      
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "cust",
          sortable: true,
          label: "CUSTOMER",
        },
        {
          key: "details",
          sortable: true,
          label: "PRODUCTS",
        },
        {
          key: "tt_amt",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "amt_paid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "discount_field",
          sortable: true,
          label: "DISCOUNT",
        },
        {
          key: "balance",
          sortable: true,
          label: "BALANCE",
        },        
        {
          key: "date",
          sortable: true,
          label: "DATE",
        }
      ], 
      fields1: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "cust",
          sortable: true,
          label: "CUSTOMER",
        },
        {
          key: "details",
          sortable: true,
          label: "PRODUCTS",
        },
        {
          key: "tt_amt",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "amt_paid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "discount_field",
          sortable: true,
          label: "DISCOUNT",
        },
        {
          key: "balance",
          sortable: true,
          label: "BALANCE",
        },        
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "branch.name",
          sortable: true,
          label: "BRANCH",
        }
      ],
      fields2: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "cust",
          sortable: true,
          label: "CUSTOMER",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "pay_date",
          sortable: true,
          label: "EXPECTED PAY DATE",
        },
        {
          key: "remaining_days",
          sortable: true,
          label: "DAYS REMAINING",
        },
        {
          key: "details",
          sortable: true,
          label: "PRODUCTS",
        },
        {
          key: "tt_amt",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "amt_paid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "discount_field",
          sortable: true,
          label: "DISCOUNT",
        },
        {
          key: "balance",
          sortable: true,
          label: "BALANCE",
        }
      ],  
      fields3: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "cust",
          sortable: true,
          label: "CUSTOMER",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "pay_date",
          sortable: true,
          label: "EXPECTED PAY DATE",
        },
        {
          key: "remaining_days",
          sortable: true,
          label: "DAYS REMAINING",
        },
        {
          key: "details",
          sortable: true,
          label: "PRODUCTS",
        },
        {
          key: "tt_amt",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "amt_paid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "discount_field",
          sortable: true,
          label: "DISCOUNT",
        },
        {
          key: "balance",
          sortable: true,
          label: "BALANCE",
        },
        {
          key: "branch.name",
          sortable: true,
          label: "BRANCH",
        }
      ],    
    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("saledetails", ["SaveStatus","Debtors","filterStatus"]),
    ...mapGetters("setting", ["PaymentOptions","GeneralSettings"]),
    ...mapGetters("auth", ["business","branch","Branches","branchid"]),
    ...mapGetters("customers", ["Customers"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.filteredReport ? this.filteredReport.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.filteredReport ? this.filteredReport.length : 1;
  },
  methods: {
    ...mapActions({
      FetchDebtors: "saledetails/fetchDebtors",
      FetchCustomers: "customers/fetchCustomers",
      FetchBranches: "auth/fetchBranches",
      FetchGeneralSettings: "setting/fetchGeneralSettings",

    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    filterReport(){
      this.FetchDebtors(this.data);      
    },


    Excel_export() {
      axios
        .post("export_debtors", this.data,{
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "debtors_report.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          this.spinner = false;
        })
        .catch(() => {
        });
    },    
  },
  
  created() {
    this.FetchDebtors(this.data); 
    this.FetchCustomers();
    this.FetchBranches(); 
    this.FetchGeneralSettings();
  },

  updated(){
    if(this.Debtors){
      this.filteredReport = this.Debtors; 
      let total_amount = 0;
      let total_paid = 0;
      let total_discount = 0;
      this.Debtors.forEach((item)=>{
        total_amount = total_amount+parseInt(item.totalAmt);
        total_paid = total_paid+parseInt(item.totalPaid);
        total_discount = total_discount+parseInt(item.discount);

        this.totals.totalBalance = this.totals.totalAmount-(this.totals.totalPaid+this.totals.totalDiscount);
      });
      this.totals.totalPaid = total_paid;
      this.totals.totalAmount = total_amount;
      this.totals.totalDiscount = total_discount;  
      this.totals.totalBalance = total_amount-(total_paid+total_discount)
    }
  }
};
</script>

<template>
  <Layout>
    <div class="row py-3 text-center">
      <h4 v-if="GeneralSettings.show_businessname == 1" class="text-primary">{{business}}</h4><h4 v-if="GeneralSettings.show_branchname == 1 && branch"> <em  v-if="GeneralSettings.show_branchname == 1 && GeneralSettings.show_businessname == 1">-</em> {{branch}}</h4>
    </div>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body"> 
            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-4 mb-3" v-if="branchid == 0"> 
                <label>FILTER BY BRANCHES</label>
                
                <model-list-select
                  :list="Branches ? Branches : []"
                  v-model="data.branch_id"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Branch"
                  @input="filterReport()"
                >
                </model-list-select>
            </div>
            </div>           
            <div class="row">
              <h4>
                <center>{{ filterTitle }}</center>
              </h4>              
              <div class="col-3 mt-4">
                <b-button variant="info" @click="Excel_export()"
                  ><i class="fa fa-download"></i>Export</b-button>
              </div>
              <div class="col-2">
                <div class="form-group">
                  <label>From</label>
                  <input
                    @change="filterReport()"
                    type="date"
                    v-model="data.datefrom"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-2">
                <div class="form-group">
                  <label>To</label>
                  <input
                    @change="filterReport()"
                    type="date"
                    v-model="data.dateto"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3 form-group">
                <label>CUSTOMERS</label>
                
                <model-list-select
                  :list="Customers ? Customers : []"
                  v-model="data.customer"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Customer"
                  @input="filterReport()"
                >
                </model-list-select>
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn btn-primary" type="button" @click="filterReport()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="filterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="filteredReport?filteredReport:[]"
                  :fields="GeneralSettings.set_debtpay_date != 0 && branchid==0?fields3:(GeneralSettings.set_debtpay_date != 0 && branchid !=0?fields2:(GeneralSettings.set_debtpay_date == 0 && branchid ==0?fiels1:fields))"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(tt_amt)="data">
                  {{ (data.item.totalAmt).toLocaleString() }}
                </template>
                <template #cell(cust)="data">
                    {{ data.item.customer }}-{{ data.item.customerPhone }}
                </template>
                <template #cell(amt_paid)="data">
                    {{ (data.item.totalPaid).toLocaleString() }}
                </template>
                <template #cell(discount_field)="data">
                  {{ (data.item.discount).toLocaleString() }}
                </template>
                <template #cell(balance)="data">
                  {{ data.item.balance?(data.item.balance).toLocaleString():0 }}
                </template>
                <template #cell(details)="data">
                  <table  class="table">
                    <tbody>
                    <tr v-for="(det,d) in data.item.items" :key="d" width="100%">
                      <td>{{ det.product }}</td>
                      <td>{{ det.chassis }}</td>
                      <td>{{ det.description }}</td>
                    </tr>
                    </tbody>
                  </table>
                </template>
                <template #cell(pay_date)="data">
                  <span>{{ new Date(data.item.pay_date).toISOString().split('T')[0] }}</span>                  
                </template>
                <template #cell(remaining_days)="data">
                  {{ Math.floor((new Date(data.item.pay_date) - new Date(new Date().toISOString().split('T')[0]))/ (1000 * 60 * 60 * 24)) }} days
                </template>
              </b-table>
                <div class="row">
                  <div class="col-md-3">
                    <h5>Total Amount: <span class="text-danger">{{(totals.totalAmount).toLocaleString()}}</span></h5>
                  </div>
                  <div class="col-md-3">
                    <h5>Total Paid: <span class="text-danger">{{(totals.totalPaid).toLocaleString()}}</span></h5>
                  </div>
                  <div class="col-md-3">
                    <h5>Total Discount: <span class="text-danger">{{(totals.totalDiscount).toLocaleString()}}</span></h5>
                  </div>
                  <div class="col-md-3">
                    <h5>Total Balance: <span class="text-danger">{{(totals.totalBalance).toLocaleString()}}</span></h5>
                  </div>
                </div>
            </div>
            <Loader  v-if="!Debtors"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
